'use client';

import Script from 'next/script';
import { useEffect, useState } from 'react';
import { useConsent } from './ConsentProvider';
import {
  LV_ATTRIBUTION_SRC,
  LV_COOKIE_DOMAIN,
  applyConsentToLVAttribution,
  type LVAttributionApi,
} from './lvAttribution.helpers';

declare global {
  interface Window {
    LVAttribution?: LVAttributionApi;
  }
}

/**
 * Loads the CRM's marketing-attribution script on every page and drives its
 * consent gate. The script captures the entry URL into memory at load but writes
 * nothing until we call init() — which we do only once the visitor has granted
 * the marketing category. Withdrawing consent calls clear() to erase the cookies.
 * Mount inside ConsentProvider (it reads useConsent()).
 */
export function LVAttribution() {
  const { record } = useConsent();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (!ready) return;
    applyConsentToLVAttribution(window.LVAttribution, record?.marketing, LV_COOKIE_DOMAIN);
  }, [ready, record]);

  return (
    <Script
      src={LV_ATTRIBUTION_SRC}
      strategy="afterInteractive"
      data-cookie-domain={LV_COOKIE_DOMAIN}
      onReady={() => setReady(true)}
    />
  );
}
